import { Component, OnInit } from '@angular/core';

import { EventNewParams } from '../shared/new/event-new-params.model';
import { EventDateTimeDto } from '../shared/new/eventDateTime.model';

import { DialogService, DatagridService, UtilService } from '../../shared/index'; //app/shared/index barrel;
import { NavigationService } from '../../shared/navigation/navigation.service';
import { AuthService } from '../../shared/auth/auth.service';
import { EventsV4Service } from '../shared/events-v4.service';

@Component({
  selector: 'wl-events-v4-new',
  templateUrl: 'events-v4-new.component.html',
  styleUrls: ['events-v4-new.component.css'],
  providers: [EventsV4Service, DatagridService, EventNewParams],
    standalone: false
})
export class EventsV4NewComponent implements OnInit {
  public _dialogService: DialogService;
  public showModal = false;
  public errorMessage: string;
  public eventNewParams: EventNewParams;
  public saving: boolean = false;
  public displaySeparateHours: boolean = false;

  get showStartEndTime(): boolean {
    return !this.displaySeparateHours && !this.eventNewParams.IsAllDay;
  }

  get showSeparateHoursCheckbox(): boolean {
    return !this.eventNewParams.IsAllDay && !this.startDateIsEqualToEndDate();
  }

  get showSeparateHoursSection(): boolean {
    return this.displaySeparateHours && !this.eventNewParams.IsAllDay;
  }

  public constructor(
    private _eventsService: EventsV4Service,
    private _navService: NavigationService,
    private _authService: AuthService,
    private _utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.reset();
  }

  public reset() {
    this.eventNewParams = new EventNewParams();
    this.displaySeparateHours = false;
  }

  public open = () => {
    this.showModal = true;
  };

  public newCancel = (): void => {
    this.showModal = false;
  };

  public startDateChanged(newDate: Date): void {
    this.eventNewParams.EndDate = newDate;
    this.endDateChanged();
  }

  public endDateChanged(): void {
    if (!this.isValidDateRange()) {
      this.displaySeparateHours = false;
      return;
    }
    this.updateEventDates();
  }

  public startDateIsEqualToEndDate(): boolean {
    if (this.eventNewParams.StartDate === null || this.eventNewParams.EndDate === null) {
      this.displaySeparateHours = false;
      return false;
    }

    return this._utilService.datesAreEqual(this.eventNewParams.StartDate, this.eventNewParams.EndDate);
  }

  public setHoursSeparatelyChanged(checkboxEvent: { checked: boolean }): void {
    if (checkboxEvent.checked) {
      this.clearStarEndTimes();
    }
  }

  public allDayChanged(checkboxEvent: { checked: boolean }): void {
    if (!checkboxEvent.checked) {
      this.displaySeparateHours = false;
    } else {
      this.clearStarEndTimes();
    }
  }

  public createEvent(event: any): void {
    this.saving = true;

    // default event email to current user email.
    this._authService.getUserInfo().then((userInfo) => {
      this.eventNewParams.Email = userInfo.email;

      this.prepareEventParams();
      this.submitEvent();
    });
  }

  private clearStarEndTimes(): void {
    this.eventNewParams.StartTime = '';
    this.eventNewParams.EndTime = '';
  }

  private isValidDateRange(): boolean {
    return this.eventNewParams.StartDate && this.eventNewParams.EndDate && !this.startDateIsEqualToEndDate();
  }

  private updateEventDates(): void {
    let currentDate = this._utilService.clone(this.eventNewParams.StartDate);
    this.eventNewParams.EventDateTimes = [];

    while (currentDate <= this.eventNewParams.EndDate) {
      this.eventNewParams.EventDateTimes.push({ EventDate: this._utilService.clone(currentDate) } as EventDateTimeDto);
      currentDate = this._utilService.addDays(currentDate, 1);
    }
  }

  private prepareEventParams(): void {
    if (!this.displaySeparateHours || this.eventNewParams.IsAllDay) {
      this.eventNewParams.EventDateTimes = [];
    }

    if (this.eventNewParams.IsAllDay) {
      this.eventNewParams.StartTime = '';
      this.eventNewParams.EndTime = '';
    }
  }

  private submitEvent(): void {
    this._eventsService
      .createEvent(this.eventNewParams)
      .then((data: any) => {
        this.saving = false;
        this.showModal = false;
        this._navService.navigateToEventV4(data);
      })
      .catch((error: any) => {
        this.saving = false;
        this.errorMessage = this._utilService.extractErrorMessage(error);
      });
  }
}
